/** Pathless application layout, holding the provider tree. */
import { Outlet, createFileRoute } from "@tanstack/react-router";

import AppShell from "@/shell/AppShell";

export const Route = createFileRoute("/_app")({
  component: DashboardShell,
});

function DashboardShell() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
